import {Bounds, Dataset} from "../types/Types";

/**
 * Calculates the bounding box of the given dataset by determining the minimum and maximum x and y coordinates.
 */
export function getDatasetBounds(dataset: Dataset | undefined): Bounds | null {
  if (!dataset) return null;

  let minX = Number.MAX_SAFE_INTEGER;
  let maxX = -Number.MAX_SAFE_INTEGER;
  let minY = Number.MAX_SAFE_INTEGER;
  let maxY = -Number.MAX_SAFE_INTEGER;

  for (const node of dataset.nodes) {
    if (!!node.x) {
      if (node.x < minX) minX = node.x;
      if (node.x > maxX) maxX = node.x;
    }
    if (!!node.y) {
      if (node.y < minY) minY = node.y;
      if (node.y > maxY) maxY = node.y;
    }
  }

  return {minX, maxX, minY, maxY};
}